import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center justify-end space-x-3" }
const _hoisted_4 = {
  key: 0,
  href: "/settings/regions/create"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1)
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = { class: "w-full border rounded-lg border-neutral-100" }
const _hoisted_8 = { class: "relative overflow-auto" }
const _hoisted_9 = { class: "absolute left-0 top-0 h-full whitespace-nowrap position w-[181px] shadow-[2px_0_16px_0px_rgb(0,0,0,0.08)]" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-[26px] bg-primary-100 text-sm font-semibold relative" }, "Settings", -1)
const _hoisted_11 = { class: "pl-[181px] min-h-[500px]" }
const _hoisted_12 = { class: "flex items-center justify-between p-6 border-b border-neutral-100" }
const _hoisted_13 = { class: "flex items-center space-x-4" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-semibold" }, "All Records", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "space-y-5" }
const _hoisted_19 = { class: "px-6 py-[18px] text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_20 = { class: "px-6 py-[18px] text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_21 = { class: "px-6 py-[18px] text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_22 = { class: "px-6 py-[18px] text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_23 = { class: "px-6 py-[18px] text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_24 = { class: "flex items-center justify-center mx-auto w-max" }
const _hoisted_25 = { class: "w-full px-6 border-t py-7" }

import { ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import UserLayout from '@/layouts/UserLayout.vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import ExportButton from '@/components/buttons/ExportButton.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import EditButton from "@/components/buttons/EditButton.vue";
import SideTab from "@/views/settings/Components/SideTab.vue";

import RestoreButton from "@/components/buttons/RestoreButton.vue";
import DeleteButton from '@/components/buttons/DeleteButton.vue';
import DataTable from '@/components/partials/DataTable.vue';
import FilterPanel from '@/components/partials/FilterPanel.vue';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import TabComponent from '@/components/partials/TabComponent.vue';
import DatePicker from "@/components/inputs/DatePicker.vue";
import { PlusIcon } from '@heroicons/vue/24/outline';
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";

import { hasPermission } from "@/classes/AuthService";

import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import debounce from "lodash/debounce";

import RegionService from "@/classes/Settings/Locations/RegionService";

import { SelectInterface } from "@/interfaces/pages/offices/OfficeInterface"

import assignValues from "@/helpers/assignValues"
import PageLoader from "@/components/loaders/PageLoader.vue"

import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"

import { filters, items } from "@/interfaces/pages/FilterPageInterface";

import DateFormatter from "@/helpers/DateFormatter";



export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const showFilter = ref<boolean>(false);
const loading = ref<boolean>(false);

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);

const selectedId = ref<number|null>(null);
const tabs = ref();

const headers: { text: string, haveSort?: boolean }[] = [
    { text: 'Code' },
    { text: 'Region' },
    { text: 'No. Provinces' },
    { text: 'Date Created' },
];

/**
 * METHODS
 */
const getData = (): void => {
    loading.value = true
    RegionService.index(pickBy(filters.value))
        .then(({ data }) => {
            items.value = data.items;
            filters.value = assignValues(filters.value, data);
        
            loading.value = false;

            tabs.value = [
                {
                    name: "All",
                    count: filters.value.allItemsCount,
                    tab: null,
                    allowed: true,
                },
                {
                    name: "Archived",
                    count: filters.value.archiveItemsCount,
                    tab: "archived",
                    allowed: true,
                },
                {
                    name: "Action Logs",
                    count: filters.value.activityLogsCount,
                    tab: "activity_logs",
                    allowed: true,
                }, 
            ]

        })
        .catch((error: any) => {
            console.log(error);
        });
};

const applyFilters = (search: any = null) => {
    showFilter.value = false;
    filters.value.query = search;
    getData();
};

const applyReset = () => {
    filters.value.filterDate = null;
    showFilter.value = false;
    getData();

};

const paginate = ({ page, rows }): void => {
    filters.value = Object.assign(filters.value, {
        page, rows
    })

    getData();
};

const updateTab = (currentTab: string) => {
    filters.value.tab = currentTab;
    filters.value.page = 1;
    applyFilters();
};

/**
 * MODALS
 */
const showDeleteModal = (item: any): void => {
    showConfirmation.value = true;
    selectedId.value = item.id;
};

const closeDeleteModal = (): void => {
    showSuccess.value = false;
};

const deleteRecord = (): void => {
    RegionService.delete(selectedId.value)
        .then(() => {
            showSuccess.value = true;
            showConfirmation.value = false;
            applyFilters();
        })
        .catch((error) => console.log(error));
};

const showRestoreModal = (item: any): void => {
    showRestoreConfirmation.value = true;
    selectedId.value = item.id;
};

const closeRestoreModal = (): void => {
    showRestoreSuccess.value = false;
};

const restoreRecord = (): void => {
    RegionService.restore(selectedId.value)
        .then(() => {
            showRestoreSuccess.value = true;
            showRestoreConfirmation.value = false;
            applyFilters();
        })
        .catch((error) => console.log(error));
};

/**
 * WATCHERS
 */
watch(
    () => filters.value.query,
    debounce(() => {
        filters.value.page = 1;
        getData();
    }, 1000)
);

onMounted(() => {
    getData();
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Regions",
            description: "View the relevant in the system."
          }),
          _createElementVNode("div", _hoisted_3, [
            (_unref(hasPermission)('can-create-department'))
              ? (_openBlock(), _createElementBlock("a", _hoisted_4, [
                  _createVNode(ButtonComponent, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(SideTab, { regionSelected: "" })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(TabComponent, {
                      tabs: tabs.value,
                      "onUpdate:tab": _cache[0] || (_cache[0] = (value) => updateTab(value))
                    }, null, 8, ["tabs"])
                  ])
                ]),
                (_unref(filters).tab != 'activity_logs')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(DataTable, {
                        headers: headers,
                        "no-action": false,
                        count: _unref(items).total,
                        hasSearch: true,
                        searchPlaceholder: "Search region",
                        tableClass: "header-frm-table",
                        dataTableClass: "border-0",
                        "onUpdate:searchText": _cache[6] || (_cache[6] = (value) => (_unref(filters).query = value))
                      }, {
                        topContent: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "flex items-center px-3 py-2 space-x-1 transition border border-solid rounded border-neutral-100 hover:bg-primary-100 w-max",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (showFilter.value = true))
                            }, _hoisted_17),
                            _createVNode(FilterPanel, {
                              show: showFilter.value,
                              onClose: _cache[3] || (_cache[3] = ($event: any) => (showFilter.value = false)),
                              "onApply:reset": _cache[4] || (_cache[4] = ($event: any) => (applyReset())),
                              "onApply:filters": _cache[5] || (_cache[5] = ($event: any) => (applyFilters()))
                            }, {
                              fields: _withCtx(() => [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(DatePicker, {
                                    id: "date_created",
                                    name: "date_created",
                                    label: "Date Created",
                                    modelValue: _unref(filters).filterDate,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).filterDate) = $event)),
                                    range: true
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" > ")
                              ]),
                              _: 1
                            }, 8, ["show"])
                          ])
                        ]),
                        body: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data, (item) => {
                            return (_openBlock(), _createElementBlock("tr", { key: item }, [
                              _createElementVNode("td", _hoisted_19, _toDisplayString(item.code), 1),
                              _createElementVNode("td", _hoisted_20, _toDisplayString(item?.name), 1),
                              _createElementVNode("td", _hoisted_21, _toDisplayString(item?.no_locations), 1),
                              _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(DateFormatter).defaultTimeStamp(item.created_at)), 1),
                              _createElementVNode("td", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  (!_unref(filters).tab)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(hasPermission)('can-update-department'))
                                          ? (_openBlock(), _createBlock(EditButton, {
                                              key: 0,
                                              onClick: ($event: any) => (_unref(router).replace(`/settings/regions/edit/${item.id}`))
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (_unref(hasPermission)('can-archive-department'))
                                          ? (_openBlock(), _createBlock(DeleteButton, {
                                              key: 1,
                                              onClick: ($event: any) => (showDeleteModal(item))
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_unref(filters).tab == 'archived')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_unref(hasPermission)('can-archive-department'))
                                          ? (_openBlock(), _createBlock(RestoreButton, {
                                              key: 0,
                                              onClick: ($event: any) => (showRestoreModal(item))
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["count"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(filters).tab == 'activity_logs')
                  ? (_openBlock(), _createBlock(ActivityLogsTable, {
                      key: 1,
                      items: _unref(items)
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(SimplePagination, {
                numRows: _unref(filters).rows,
                currentPage: _unref(items).current_page,
                "last-page": _unref(items).last_page,
                onUpdate: _cache[7] || (_cache[7] = (value) => paginate(value))
              }, null, 8, ["numRows", "currentPage", "last-page"])
            ])
          ])
        ])
      ]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showConfirmation.value,
        onCancel: _cache[8] || (_cache[8] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => (deleteRecord())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Delete Record",
        content: "Are you sure you wish to delete this Region?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[10] || (_cache[10] = ($event: any) => (closeDeleteModal())),
        "action-text": "Close",
        title: "Record Deleted!",
        content: "Selected region has been successfully deleted!"
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showRestoreConfirmation.value,
        onCancel: _cache[11] || (_cache[11] = ($event: any) => (showRestoreConfirmation.value = false)),
        onConfirm: _cache[12] || (_cache[12] = ($event: any) => (restoreRecord())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Restore Record",
        content: "Are you sure you wish to restore this region?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showRestoreSuccess.value,
        onConfirm: _cache[13] || (_cache[13] = ($event: any) => (closeRestoreModal())),
        "action-text": "Close",
        title: "Record Restored!",
        content: "Selected region has been successfully region!"
      }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})